import { DocumentService } from '@core/services/DocumentService';
import { DATA, META } from '@/plugins/vuex-async-pagginate';

function get_computed_confirmation_type(item, documents_status_count) {
  const { confirmation_type } = item;
  const { new_count, approved_count } = documents_status_count;
  const statuses = {
    support: confirmation_type === 'support',
    required_documents: approved_count === null && new_count === null,
    need_verification: approved_count === null && new_count > null,
    allow_buying: confirmation_type === null || approved_count > 0
  };
  const true_statuses = Object.keys(statuses).filter(key => statuses[key] === true);

  return true_statuses.length ? true_statuses[0] : 'none';
}

export const BuyNumberFormatter = {
  formatItem: function(item, documents_status_count) {
    const computed_confirmation_type = get_computed_confirmation_type(item, documents_status_count);

    return { ...item, computed_confirmation_type };
  },

  formatItems: function(items = [], documents_status_count) {
    return items.map(item => BuyNumberFormatter.formatItem(item, documents_status_count));
  },

  formatItemWithPaginate: async function(response) {
    let documents_status_count = { approved_count: 0 };

    try {
      documents_status_count = await DocumentService.getStatusInfo();
    } catch (e) {
      console.error('Ошибка получения информации о документах');
    }

    return {
      [META]: response[META],
      [DATA]: BuyNumberFormatter.formatItems(response[DATA], documents_status_count)
    };
  }
};
